module.exports = __webpack_public_path__ + "img/empty-bag.94b6c9d5.png";